.cardGroup {
	display: flex;
	justify-content: space-between;
	flex-wrap: wrap;
	margin-bottom: 16px;
	gap: 12px;
}

.card {
	background: #f9fafb;
	border-radius: 12px;
	padding: 16px 24px;
	min-width: 220px;
	flex: 1;
	border: 1px solid #bbbbbb;
}

.titleCard {
	font-size: 14px;
	color: #6b7280;
	margin-bottom: 4px;
}

.valueCard {
	font-size: 28px;
	font-weight: 700;
	color: #111827;
	margin-bottom: 0px;
}

.valueCardBad {
	@extend .valueCard;
	color: #dc3535e3;
}

.valueCardGood {
	@extend .valueCard;
	color: #7fb02f;
}

.subtext {
	font-size: 13px;
	color: #6b7280;
}

.positive {
	color: #7fb02f;
	font-weight: 600;
}

.negative {
	color: #dc2626;
	font-weight: 600;
}

.graphHeader {
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin: 16px 0 12px 0;
}

.graphTitle {
	font-size: 16px;
	font-weight: 600;
	color: #374151;
	margin: 0;
}

.periodSelector {
	padding: 6px 12px;
	border: 1px solid #d1d5db;
	border-radius: 8px;
	background-color: white;
	color: #374151;
	font-size: 14px;
	cursor: pointer;

	&:hover {
		border-color: #7fb02f;
	}
}

.progressWrapper {
	margin-top: 16px;
}

.progressBar {
	width: 100%;
	background-color: #e5e7eb;
	border-radius: 6px;
	height: 8px;
	overflow: hidden;
	margin-bottom: 4px;
}

.valued {
	background-color: #7fb02f;
	height: 100%;
	border-radius: 6px;
	transition: width 0.3s ease-in-out;
}

.progressLabels {
	display: flex;
	justify-content: space-between;
	font-size: 13px;
	color: #4b5563;
	margin-top: 4px;

	.valuedButton {
		color: #7fb02f;
		cursor: pointer;
		text-decoration: underline;

		&:hover {
			color: #5a8217;
		}
	}
}

.table_div {
	width: 50%;

	.table_button {
		width: 95%;
		font-size: 13px;
		background-color: #81ba43;
		border-radius: 5px;
		padding: 8px 10px;
		cursor: pointer;
		border: 1px solid #81ba43;
		color: white;
		text-align: center;

		&:hover {
			background-color: #5d9125;
			border: 1px solid #5d9125;
		}

		&.active {
			background-color: white;
			color: #81ba43;
			border: 1px solid #81ba43;
		}

		&.fetching {
			background-color: #dee2e6;
			color: #5e5e5e;
			border: 1px solid #a8a8a8;
		}
	}
}

.table_dashboard {
	.th {
		background-color: #81ba43;
		padding: 5px;
		font-weight: 400;
		border: none;
		color: white;
		text-align: center;
	}

	.td {
		font-size: 13px;
		padding: 5px;

		&.center {
			text-align: center;
		}
	}

	.button_confirm {
		display: flex;
		justify-content: center;
		padding: 6px;
	}
}
